<dx-popup
  [width]="1200"
  [height]="'auto'"
  [maxHeight]="500"
  [minHeight]="700"
  [showTitle]="true"
  [title]="'MANAGE-ELEARNING.OVERVIEW.ARCHIVE-ELERNINGS' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  class="modal"
  [classList]="'modal'"
  [visible]="showModal"
  (onHidden)="dismiss()"
>
  <div *dxTemplate="let data of 'content'" class="modal-content">
    <div class="modal-text">
      <p>{{ "MANAGE-ELEARNING.OVERVIEW.ARCHIVE-ELERNINGS-TEXT" | translate }}</p>
    </div>
    <app-table
      class="merge-table"
      [data]="elernings"
      [columns]="elerningColumns"
      [showSearch]="false"
    ></app-table>
    <div class="modal-buttons">
      <dx-button
        class="cta-btn"
        type="default"
        [text]="'COMMON.CANCEL' | translate"
        (click)="dismiss()"
      ></dx-button>
      <dx-button
        class="cta-btn"
        type="normal"
        [text]="'MANAGE-ELEARNING.OVERVIEW.ARCHIVE-NOW' | translate"
        (click)="onSubmit()"
      ></dx-button>
    </div>
  </div>
</dx-popup>
